@if (orderSelection.hasSelection() && !orderSelection.showOrderProcess()) {
<div class="text-center my-2">
    <button class="btn btn-success" style="font-size: 30px;" id="startOrderBtn" (click)="onStartOrder()">
        Start Your Order ({{ orderSelection.totalDocCount() }})
    </button>
</div>
}